/// <reference path="../../typings/moment/moment.d.ts" />

import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "dateformat" })

export class DateformatPipe implements PipeTransform {
  constructor() { }

  transform(value: any, format: string = ""): string {
    // Try and parse the passed value.
    let momentDate = moment(value);

    // If moment didn't understand the value, return it unformatted.
    if (!momentDate.isValid()) return value;

    // Otherwise, return the date formatted as requested.
    return momentDate.format(format);
  }
}
